import {
  getBoardStatusLabel,
  getWorkflowStatusOptionsForDepartment,
} from "./departmentBoard";
import { DEFAULT_DEPARTMENT } from "./departments";

/**
 * Issue workflow status stored in DB/API. Kanban column key for the QA/review stage.
 * UI label varies by department (see getBoardStatusLabel).
 */
export const ISSUE_STATUS_TESTING = "Testing";

/** User-facing label for an issue status value. Pass department for Kanban-specific naming. */
export function issueStatusLabel(status, department) {
  if (status == null || status === "") return "";
  return getBoardStatusLabel(status, department || DEFAULT_DEPARTMENT);
}

/** Workflow statuses on Kanban cards and issue detail selects. */
export function getWorkflowStatusOptions(department) {
  return getWorkflowStatusOptionsForDepartment(department || DEFAULT_DEPARTMENT);
}

/** @deprecated Prefer getWorkflowStatusOptions(department) */
export const WORKFLOW_STATUS_OPTIONS = getWorkflowStatusOptionsForDepartment(DEFAULT_DEPARTMENT);

/** Legacy bug resolution stored in DB — same meaning as Not Reproducible. */
export const LEGACY_CANNOT_REPRODUCE_STATUS = "Cannot Reproduce";

export function normalizeBugResolutionStatus(status) {
  if (status === LEGACY_CANNOT_REPRODUCE_STATUS) return "Not Reproducible";
  return status;
}
